export const openExternalUrl = (link: string) => {
  const reg = new RegExp('^(http|https)://', 'i');
  if (reg.test(link)) {
    window.open(link);
  } else {
    window.open('https://' + link);
  }
};
